<template>
    <section>
        <b-field>
            <!--This should be populated from DB, but I doubt it will ever change-->
            <b-radio v-model="ivaCondition" :native-value="3">Consumidor Final</b-radio>
            <b-radio v-model="ivaCondition" :native-value="1">Responsable Inscripto</b-radio>
        </b-field>

        <template v-if="ivaCondition === 1">
            <b-field grouped>
                <b-field label="Razón Social" expanded :type="errors.has('name') ? 'is-danger' : ''" :message="errors.first('name')">
                    <b-input name="name" v-model="data.name" v-validate="'required'" expanded></b-input>
                </b-field>

                <b-field label="CUIT" :type="errors.has('cuit') ? 'is-danger' : ''" :message="errors.first('cuit')">
                    <div class="control">
                        <cleave name="cuit"
                                class="input"
                                v-model="data.cuit"
                                v-validate="'required'"
                                placeholder="xx-xxxxxxxx-x"
                                :options="{ delimiter: '-', blocks: [2, 8, 1]}">
                        </cleave>
                    </div>
                </b-field>                
            </b-field>

            <b-field label="Dirección Fiscal" :type="errors.has('address') ? 'is-danger' : ''" :message="errors.first('address')">
                <b-input name="address" v-model="data.address" v-validate="'required'"></b-input>
            </b-field>
        </template>
        <template v-else>
            <b-field grouped>
                <b-field label="Nombre y Apellido" expanded :type="errors.has('name') ? 'is-danger' : ''" :message="errors.first('name')">
                    <b-input name="name" v-model="data.name" v-validate="'required'" expanded></b-input>
                </b-field>

                <b-field label="DNI" :type="errors.has('cuit') ? 'is-danger' : ''" :message="errors.first('cuit')">
                    <!-- <b-input name="cuit" v-model="data.cuit" v-validate="'required|numeric'" placeholder="xxxxxxxx"></b-input> -->
                    <div class="control">
                        <cleave name="cuit"
                                class="input"
                                v-model="data.cuit"
                                v-validate="'required'"
                                placeholder="xxxxxxxx"
                                :options="{ numeral: true, numeralPositiveOnly: true }">
                        </cleave>
                    </div>
                </b-field>
            </b-field>

            <b-field label="Dirección Fiscal" :type="errors.has('address') ? 'is-danger' : ''" :message="errors.first('address')">
                <b-input name="address" v-model="data.address" v-validate="'required'"></b-input>
            </b-field>
        </template>      

        <div class="modal-footer field is-grouped is-grouped-right">
            <b-button v-if="canCancel" class="button" @click.prevent="onCloseSelected">Cancelar</b-button>
            <b-button class="button is-primary" @click.prevent="onSaveSelected">Guardar</b-button>
        </div>
    </section>
</template>

<script>
    import Cleave from 'vue-cleave'

    export default {
        name: 'BillingAddressCreate',
        props: {
            canCancel: {
                type: Boolean,
                default: true
            },

            billingAddress: {
                type: Object
            }
        },
        components: {Cleave},

        data() {
            return {
                ivaCondition: 3,
                data: {
                    name: '',
                    address: '',
                    cuit: ''
                }
            }
        },

        computed: {
            customer() {
                return this.$store.getters['customer/get']();
            },

            addresses() {
                return this.customer.billingAddresses;
            }
        },

        watch: {
            ivaCondition: {
                immediate: true,
                handler(val) {
                    // huge hack, server should just send a "code"... but for now we have this legacy stuff to deal with.
                    let valueToTest = val === 1 ? 'Responsable Inscripto' : 'Consumidor Final';

                    let addresses = this.addresses.filter(a => a.ivaCondition === valueToTest);
                    if(addresses.length <= 0) {
                        this.data = {
                            id: null,
                            name: '',
                            address: '',
                            cuit: ''
                        };
                        return;
                    }

                    let address = addresses[0];
                    this.data.id = address.id;
                    this.data.name = address.name;
                    this.data.cuit = address.cuit;
                    this.data.address = address.address;
                }
            }
        },

        mounted() {
        },

        methods: {
            async onSaveSelected() {
                try {
                    await this.validate();

                    let address = null;

                    if(this.data.id) {
                        address = await this.$store.dispatch('customer/updateBillingAddress', {
                            address: { 
                                id: this.data.id 
                            },
                            data: {
                                name: this.data.name,
                                address: this.data.address,
                                cuit: parseInt(this.data.cuit.replace(/,|-/g, ''))
                            }
                        });
                    }
                    else {
                        address = await this.$store.dispatch('customer/addBillingAddress', {
                            data: {
                                name: this.data.name,
                                ivaCondition: this.ivaCondition,
                                address: this.data.address,
                                cuit: parseInt(this.data.cuit.replace(/,|-/g, ''))
                            }
                        });
                    }
                                    
                    this.$emit('input', address);
                    this.$emit('close');
                } 
                catch(error) {
                    if(error.code === 'error.request.invalid') {
                        Object.keys(error.errors).forEach((key) => {
                            let value = error.errors[key];
                            this.errors.add({field: key, msg: value});
                        });
                    }

                    throw error;
                }
            },

            onCloseSelected() {
                this.$emit('close');
            },

            validate() {
                return this.$validator.validate().then(result => {
                    if(!result)
                        throw new Error();
                });
            }
        }
    }
</script>

<style scoped>

</style>